// DTO de S7 — mis acciones (auditoría personal del supervisor).
//
// GET /api/supervisor/mis-acciones?dias=7
//
// Consume eventos_auditoria filtrando por user_id_actor = ctx + tenant via RLS.
// Por defecto últimos 7 días. Solo acciones operativas (registros + paros);
// excluye login/logout/exports.
import { z } from 'zod';
export const tipoEventoSchema = z.enum([
    'create',
    'update',
    'delete',
    'soft_delete',
    'restore',
    'login',
    'logout',
    'suplantacion_inicio',
    'suplantacion_fin',
    'export',
    'import',
]);
export const accionSupervisorSchema = z.object({
    id: z.string().uuid(),
    created_at: z.string().datetime({ offset: true }),
    tipo_evento: tipoEventoSchema,
    entidad_tipo: z.string(),
    entidad_id: z.string().uuid().nullable(),
    campo_cambiado: z.string().nullable(),
    razon: z.string().nullable(),
    /**
     * Label humanamente legible, computado en backend según (entidad_tipo,
     * tipo_evento, campo_cambiado). Ejemplos:
     *   - "Validó captura del bloque 14:00"
     *   - "Invalidó captura (cantidad incorrecta)"
     *   - "Capturó por delegación"
     *   - "Cerró paro"
     *   - "Editó cantidad_procesada"
     */
    label_accion: z.string(),
    /** Resumen corto del contexto (línea, bloque) si se puede derivar del valor_nuevo. */
    contexto: z.string().nullable(),
});
export const supervisorMisAccionesSchema = z.object({
    user: z.object({
        id: z.string().uuid(),
        email: z.string().email(),
        nombre: z.string(),
        apellido: z.string(),
    }),
    tenant: z.object({ id: z.string().uuid(), nombre: z.string() }),
    hora_servidor: z.string(),
    fecha_hoy: z.string(),
    dias: z.number().int().positive(),
    rango: z.object({ desde: z.string(), hasta: z.string() }),
    /**
     * Conteo de acciones por tipo (útil para badges en UI).
     * Ejemplo: { create: 2, update: 5, soft_delete: 1 }
     */
    totales_por_tipo: z.record(z.string(), z.number().int()),
    total: z.number().int(),
    acciones: z.array(accionSupervisorSchema),
});
//# sourceMappingURL=supervisor_mis_acciones.js.map